var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"font-bold text-lg text-center"},[_vm._v("FRIENDS")]),_c('h2',{staticClass:"font-semibold my-2"},[_vm._v("Comments")]),_c('Comments')],1)}
var staticRenderFns = []

export { render, staticRenderFns }